// /identities/new — cadastro de cliente

import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { ClientForm } from '../../components/clients/ClientForm';
import { useCreateClient } from '../../hooks/use-clients';
import { extractErrorMessage } from '../../lib/errors';

export function NewClientPage(): JSX.Element {
  const navigate = useNavigate();
  const create = useCreateClient();

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-5 pb-10">
      <header className="flex flex-col gap-2">
        <button
          type="button"
          onClick={() => navigate('/identities')}
          className="inline-flex w-fit items-center gap-1 text-[12px] text-muted transition-colors hover:text-ink"
        >
          <ArrowLeft size={13} strokeWidth={2} />
          Identidades
        </button>
        <h1 className="m-0 text-[26px] font-bold leading-tight tracking-[-0.025em] text-ink">
          Novo cliente
        </h1>
        <p className="text-[13px] text-muted">
          Preencha os dados básicos. Você pode complementar contatos e endereço depois.
        </p>
      </header>

      <ClientForm
        isPending={create.isPending}
        submitLabel="Cadastrar cliente"
        onCancel={() => navigate('/identities')}
        onSubmit={async (values) => {
          try {
            const created = await create.mutateAsync(values);
            toast.success('Cliente cadastrado.', {
              description: created.name,
            });
            navigate(`/identities/${created.id}`);
          } catch (err) {
            toast.error('Não conseguimos cadastrar.', {
              description: extractErrorMessage(err, 'Tente de novo em instantes.'),
              action: {
                label: 'Tentar de novo',
                onClick: () => void create.mutateAsync(values),
              },
            });
          }
        }}
      />
    </div>
  );
}
